export enum DefinitionsNameEnum {
  LOGO = 'LOGO',
  PAYMENTS = 'PAYMENTS',
  PAYMENT_DONE = 'PAYMENT_DONE',
  CUSTOM_ETRANSPORT_UPLOAD = 'CUSTOM_ETRANSPORT_UPLOAD',
}
